module.exports = __webpack_public_path__ + "media/images/new-year/newyear-2-template-kz-8b9f44d6b4c140b83d9b11bf872e927c.png";